@if (!isLogged()) {
  <div>
    <ng-container *ngTemplateOutlet="template"></ng-container>
  </div>
}

@if (isLogged()) {
  <div>
    @if (isLogged()) {
      <app-top-navbar></app-top-navbar>
    }
    <div class="global-content" [ngClass]="{'left-navbar-collapsed': leftNavbarService.isCollapsed()}">
      <app-left-navbar class="ms-2"></app-left-navbar>
      <div class="main-content p-3 mt-1">
        <ng-container *ngTemplateOutlet="template"></ng-container>
      </div>
    </div>
  </div>
}

<ng-template #template>
  <router-outlet></router-outlet>
</ng-template>

<app-loader></app-loader>
<app-snackbar></app-snackbar>
<app-dialog-modal></app-dialog-modal>
<app-confirm-modal></app-confirm-modal>
